import Handler from "../Handler";
class DealVoteAckHandler extends Handler {
    //    DealVoteA#{"playerName":"myth974454","tourneyId":"wrefi","status":"OPTED_IN"}
    //     STATUS_TEXT can be any of

    // INVALID_MESSAGE - "opted" key may be missing

    // OPTED_IN - Indicates that player's vote is for yes has been saved

    // OPTED_OUT - Indicates that player's vote is for no has been saved

    // NOT_SEATED - The player who sent the protocol is not seated. Illegal action
    execute(message) {
        let receivedData = JSON.parse(message);
        this.service.processDealAckProtocol(receivedData);
    }
}
export default DealVoteAckHandler;
